import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-100">
      <div className="w-full px-4 md:px-6 lg:px-10 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-8">
            {/* Brand */}
            <div className="lg:col-span-1">
              <span className="font-heading text-xl font-bold text-background-50">CSS Spreadsheet</span>
              <p className="mt-3 text-sm text-foreground-300 leading-relaxed">
                Your trusted hub for verified CSSBuy spreadsheets, Kakobuy spreadsheets, Superbuy spreadsheets, and more. Updated daily for 2026.
              </p>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="text-xs font-semibold uppercase tracking-wider text-background-50 mb-4">Quick Links</h4>
              <ul className="space-y-2.5">
                <li><Link to="/" className="text-sm text-foreground-300 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">Home</Link></li>
                <li><Link to="/article/cssbuy-spreadsheet-complete-guide" className="text-sm text-foreground-300 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">CSSBuy Spreadsheet Guide</Link></li>
                <li><a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-300 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">Shop Now</a></li>
              </ul>
            </div>

            {/* Categories */}
            <div>
              <h4 className="text-xs font-semibold uppercase tracking-wider text-background-50 mb-4">Categories</h4>
              <ul className="space-y-2.5">
                {categories.slice(0, 7).map((cat) => (
                  <li key={cat.name}>
                    <a href={cat.url} target="_blank" rel="noopener nofollow" className="text-sm text-foreground-300 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">
                      {cat.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* More Categories */}
            <div>
              <h4 className="text-xs font-semibold uppercase tracking-wider text-background-50 mb-4">More</h4>
              <ul className="space-y-2.5">
                {categories.slice(7).map((cat) => (
                  <li key={cat.name}>
                    <a href={cat.url} target="_blank" rel="noopener nofollow" className="text-sm text-foreground-300 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">
                      {cat.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Bottom bar */}
          <div className="mt-12 pt-8 border-t border-foreground-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-400">
              &copy; 2026 CSS Spreadsheet Hub. All rights reserved.
            </p>
            <div className="flex items-center gap-4">
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-400 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">Privacy Policy</a>
              <span className="text-foreground-600">|</span>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-400 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">Terms</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}